// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__Qo8Bu","__regular":"label___regular___JKSy","dark":"label_dark__Uz32M"};